import React from 'react';
import style from './deployment.module.sass';
import { Checkbox, Form, Select } from 'antd';
import { useSelector } from 'react-redux';

const { Option } = Select;

interface Props {
    data: any,
    currentDeploy: any,
    envList: any,
    dmnDeploy: boolean,
    setDmnDeploy: any
    capabilities: any
}

const Deployment: React.FC<Props> = (props) => {
    const appInfo = useSelector((state: any) => state.apps.selectedApp)
    const list = props.envList
    return (
        <React.Fragment>
            {/* <h4 className={style.header}>Deployment Details</h4> */}
            {/* <div className={style.content}> */}
            <div className={'override-content row'}>
                {appInfo && appInfo.type === 'a8flow' && <div className='col-md-12'>
                    <Form.Item
                        label={"Journey"}
                    >
                        <Select data-test-id="bpmn_name" placeholder="Journey name" defaultValue={props.currentDeploy.bpmn_name} disabled style={{ width: '100%' }}>

                        </Select>
                    </Form.Item>
                </div>}
                {!props.capabilities && <div className='col-md-12'>
                    <Form.Item
                        className='select_environment'
                        label={"Environment"}
                    >
                        <Select data-test-id="select_environment" placeholder="Testing"
                            dropdownClassName='select_environment'
                            onChange={(e: string) => props.data("envId", e)} style={{ width: '100%' }}>
                            {
                                list && list.length > 0 && list.map((data: any, key: number) => {
                                    return (
                                        <Option data-test-id={`environment${data.name}`} value={data.id} key={key}>
                                            {data.name}
                                            &nbsp;<small className={style.evnHost}>({data.url})</small>
                                        </Option>
                                    );
                                })
                            }
                        </Select>
                    </Form.Item>
                </div>}
                <div className='col-md-12'>
                    <Form.Item>
                        <Checkbox value={props.dmnDeploy} onChange={(e) => props.setDmnDeploy(e.target.checked)}>Deploy DMNs</Checkbox>
                    </Form.Item>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Deployment;